import ReportDom from "../../../components/common/ReportDom";
import SalesReturnVoucherBody from "./SalesReturnVoucherBody";

export default function SalesReturnPrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <SalesReturnVoucherBody sale_r_id={id} printMode />}
    />
  );
}
